var exports = {
  "D": "xe564cbfb--f8f068--title",
  "h": "xe564cbfb--f8f068--description",
};

module.exports = exports;
